/* Header interactions ported from the pi-lit.com Astro site (src/components/Header.astro).
   Kept in sync by hand: the source is TypeScript inside an Astro <script>, so it cannot be
   generated the way assets/pilit-*.css is. Behaviour must match the site's header. */
(() => {
  const mobileToggle = document.getElementById('homeMobileNavToggle');
  const mobileDrawer = document.getElementById('homeMobileNavDrawer');
  const headerShell = document.querySelector('.header-shell');
  const accordionToggles = document.querySelectorAll('[data-mobile-accordion]');
  const accordionPanels = document.querySelectorAll('[data-mobile-panel]');

  if (mobileToggle && mobileDrawer && headerShell) {
    let closeDrawerTimer;

    const closeAccordions = () => {
      accordionToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('is-active');
      });
      accordionPanels.forEach((panel) => panel.classList.remove('is-active'));
    };

    const setMobileNavOpen = (isOpen) => {
      window.clearTimeout(closeDrawerTimer);

      if (isOpen) {
        mobileDrawer.hidden = false;
      }

      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileToggle.classList.toggle('is-active', isOpen);
      mobileDrawer.classList.toggle('is-active', isOpen);
      headerShell.classList.toggle('is-mobile-nav-open', isOpen);

      if (!isOpen) {
        closeAccordions();
        closeDrawerTimer = window.setTimeout(() => {
          mobileDrawer.hidden = true;
        }, 180);
      }
    };

    mobileToggle.addEventListener('click', () => {
      setMobileNavOpen(mobileToggle.getAttribute('aria-expanded') !== 'true');
    });

    accordionToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const panel = document.querySelector(`[data-mobile-panel="${toggle.dataset.mobileAccordion}"]`);
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
        toggle.classList.toggle('is-active', !isExpanded);
        if (panel) panel.classList.toggle('is-active', !isExpanded);
      });
    });

    mobileDrawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMobileNavOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMobileNavOpen(false);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1100) setMobileNavOpen(false);
    });
  }

  const page = document.querySelector('.home-page');
  if (page) {
    const setHeaderState = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const threshold = Math.max(1, scrollableHeight * 0.03);
      page.classList.toggle('is-header-condensed', window.scrollY >= threshold);
    };

    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
    window.addEventListener('resize', setHeaderState);
  }

  const productDropdown = document.querySelector('.nav-dropdown-products');
  const useCaseDropdown = document.querySelector('.nav-dropdown-use-cases');
  const productMega = document.querySelector('.nav-mega-products');
  const useCaseMega = document.querySelector('.nav-mega-use-cases');

  if (headerShell && productDropdown && useCaseDropdown && productMega && useCaseMega) {
    let closeMenuTimer;

    const setActiveMenu = (menu) => {
      window.clearTimeout(closeMenuTimer);
      headerShell.classList.add('is-nav-menu-open');
      headerShell.classList.toggle('is-products-menu-open', menu === 'products');
      headerShell.classList.toggle('is-use-cases-menu-open', menu === 'use-cases');
    };

    const closeActiveMenu = () => {
      closeMenuTimer = window.setTimeout(() => {
        headerShell.classList.remove('is-nav-menu-open', 'is-products-menu-open', 'is-use-cases-menu-open');
      }, 80);
    };

    const bindDesktopMenu = (dropdown, mega, menu) => {
      dropdown.addEventListener('pointerenter', () => setActiveMenu(menu));
      mega.addEventListener('pointerenter', () => setActiveMenu(menu));
      dropdown.addEventListener('pointerleave', closeActiveMenu);
      mega.addEventListener('pointerleave', closeActiveMenu);
    };

    bindDesktopMenu(productDropdown, productMega, 'products');
    bindDesktopMenu(useCaseDropdown, useCaseMega, 'use-cases');
  }
})();
